export default "__VITE_ASSET__0c0c6348__"